 
 
 export const routeConstants = {
     all: '*',
     home: '/',
     login: 'log-in',
     consumerLogin: 'consumer-login',
     consumerSignup: 'consumer-signup',
     forgotPassword: 'forgot-password',
     resetPassword: 'reset-password',
     studentLogin: 'student-login',
     apply: 'apply',
     schoolApplication: 'school-application',
     vendorApplication: 'vendor-application',
     supplementary: 'supplementary',
     dashboard: 'dashboard',
     studentDisbursement: 'disbursement',
     studentRepayment: 'repayment',
     fundManagement: 'fund-management',
     studentRecords: 'student-records',
     studentVerification: 'student-verification',
     pendingStudents: 'pending-students',
     auditLog: 'audit-log',
     consumers: 'consumers',
     consumerDashboard: 'consumer-dashboard',
     institutions: 'institutions',
     activeInstitutions: 'active-institutions',
     managers: 'managers',
     institutionDashboard: 'institution-dashboard',
     beneficiaries: 'beneficiaries',
     beneficiaryDashboard: 'beneficiary-dashboard',
     vendors: 'vendors',
     vendorDashboard: 'vendor-dashboard',
     overview: 'overview',
     overviewSummary: 'overview-summary',
     products: 'products',
     productsMgt: 'products-mgt',
     orders: 'orders',
     customers: 'customers',
     initiatives: 'initiatives',
     componentCanvas: 'component-canvas',
     batchDownload: 'batch-download',
     register: 'register',
     terms: 'terms',
     faq: 'faq',
     unauthorized: 'unauthorized',
     deactivated: 'deactivated',
     add: 'add',
     edit: 'edit',

     admin: 'admin',
    financial_institution:  'financial_institution',
    vendor:  'vendor',
    manager: 'manager',
     school_manager: 'school-manager',
     school_official: 'school-official',
     finance_manager: 'finance-manager',
     student: 'student',

     userManagement: 'user-management',
     profile: 'profile',
     appSettings: 'app-settings',
     settings: 'settings',

     marketPlace:'market-place',
     learningCenter:'learning-center',
     creditOffers:'credit-offers',
     cart: 'cart',
     checkout: 'checkout',
     profileInfo: 'profile-info',

     userLevels: {
        admin: 'admin',
        financial_admin:  'financial_admin',
        vendor:  'vendor',
        consumer:  'consumer',
        manager: 'manager',
        school_manager: 'school_manager',
        school_official: 'school_official',
        finance_manager: 'finance_manager',
        student: 'student',
     },
     userLevelIds: {
        admin: 1,
        school_official: 5,
        school_manager: 2,
        agent: 4,
     },
     userLevelKeys: [
        {
            id: 1,
            name: "admin",
        },
        {
            id: 2,
            name: "school_manager",
        },
        {
            id: 4,
            name: "manager",
        },
        {
            id: 5,
            name: "school_official",
        },
        {
            id: 6,
            name: "finance_manager",
         },
         {
             id: 6,
             name: "student",
         }
    ],
 };


 export type UserLevelType = 'admin' | 'financial_admin' | 'vendor' | 'consumer' | 'manager' | 'school_manager' | 'school_official' | 'finance_manager' | 'student';

 export enum UserLavelEnum {
    admin = 'admin',
    financial_admin =  'financial_admin',
    vendor =  'vendor',
    consumer =  'consumer',
    manager = 'manager',
    school_manager = 'school_manager',
    school_official = 'school_official',
    finance_manager = 'finance_manager',
    student = 'student',
 }
